// ...existing code...
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import useBulkEditStyles from './styles/BulkEditStyles';
import BulkEditModal from './components/BulkEditModal';

export default function BulkEditMainComponent({ onBulkEditClick, label, clientInformation, initialSyllabusInfo, onDateAdjusterConfirm, onConfirmClick, showBulkEditInLink, onClose, onUploadComplete,
  showTabsinBulkEdit, isConfirmPublishInProgress, ...props }) {
  const classes = useBulkEditStyles();
  const [modalOpen, setModalOpen] = useState(false);
  console.log('~ props coming in bulkeditmain Initial Syllabus Info:', initialSyllabusInfo);

  useEffect(() => {
    if (!showBulkEditInLink) {
      setModalOpen(true);
    }
  }, []);
  const handleClick = (event) => {
    event.preventDefault();
    setModalOpen(true);
    if (onBulkEditClick) {
      onBulkEditClick();
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    onClose();
  };

  return (
    <>
      {showBulkEditInLink &&
      <Button
        variant="text"
        className={classes.bulkEditLink}
        onClick={handleClick}
        disableRipple
      >
        {label}
      </Button>}

      <BulkEditModal
        open={modalOpen}
        onClose={handleModalClose}
        clientInformation={clientInformation}
        initialSyllabusInfo={initialSyllabusInfo}
        onDateAdjusterConfirm={onDateAdjusterConfirm}
        onUploadComplete={onUploadComplete}
        onConfirmClick={onConfirmClick}
        showTabsinBulkEdit={showTabsinBulkEdit}
        isConfirmPublishInProgress={isConfirmPublishInProgress}
        {...props}
      />
    </>
  );
}

BulkEditMainComponent.propTypes = {
  onBulkEditClick: PropTypes.func,
  label: PropTypes.string,
  clientInformation: PropTypes.object.isRequired,
  initialSyllabusInfo: PropTypes.object,
  onDateAdjusterConfirm: PropTypes.func,
  onClose: PropTypes.func,
  showBulkEditInLink: PropTypes.bool,
  onUploadComplete: PropTypes.func,
  onConfirmClick: PropTypes.func,
  showTabsinBulkEdit: PropTypes.bool,
  isConfirmPublishInProgress: PropTypes.bool
};

BulkEditMainComponent.defaultProps = {
  onBulkEditClick: () => {},
  label: 'Bulk edit assignments',
  initialSyllabusInfo: {},
  onDateAdjusterConfirm: () => {},
  onClose: () => {},
  showBulkEditInLink: false,
  onUploadComplete: () => {},
  onConfirmClick: () => {},
  showTabsinBulkEdit: false,
  isConfirmPublishInProgress: false
};
